const dataUrl = map_object.json_path;
const shortcodeTemplate = document.getElementById('template');
const shortcodeType = document.getElementById('type');
const shortcodeSearchType = document.getElementById('search__type');
const shortcodeSearchCountry = document.getElementById('search__country');
const shortcodeSearchLanguage = document.getElementById('search__language');
const shortcodeGeolocalisation = document.getElementById('geolocalisation');
const breakpoint = 768;
const weekDay = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
const storeContainer = document.getElementById('map__stores');
const mapContainer = document.getElementById('map-content');
const storeTab = document.getElementById('tab-list');
const mapTab = document.getElementById('tab-map');
const markerSize = 40;
const primaryColor = "#af2e29";
//initalisation d'un tableau pours les markers
const markers = [];
//initialisation des array
const arrayTypesCategories = [];
const arrayCategories = [];
let group;

const variables = {};
if (dataUrl, shortcodeType) {
  const params = { type: shortcodeType.value };
  variables.shortcodeTypeValue = shortcodeType.value;
  variables.shortcodeTemplateValue = shortcodeTemplate.value.toLowerCase();
  variables.shortcodeSearchTypeValue = shortcodeSearchType.value;
  variables.shortcodeSearchCountryValue = shortcodeSearchCountry.value;
  variables.shortcodeSearchLanguageValue = shortcodeSearchLanguage.value;
  variables.shortcodeGeolocalisationValue = shortcodeGeolocalisation.value;
  variables.url = new URL(`${dataUrl}`);
  variables.params = params;
  variables.breakpoint = breakpoint;
  variables.weekDay = weekDay;
  variables.storeContainer = storeContainer;
  variables.mapContainer = mapContainer;
  variables.storeTab = storeTab;
  variables.mapTab = mapTab;
  variables.primaryColor = primaryColor;
  variables.markerSize = markerSize;
  variables.markers = markers;
  variables.arrayTypesCategories = arrayTypesCategories;
  variables.arrayCategories = arrayCategories;
  variables.group = group;

  // set css variables
  document.getElementById("map").style.setProperty("--primaryColor", primaryColor);
  document.getElementById("map").style.setProperty("--markerSize", `${markerSize}`);
}

export { variables };
